import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

export function showPaymentError(err: any, fallback: string) {
  const code = err?.response?.data?.code;
  const message = err?.response?.data?.message || fallback;

  if (code === 'KYC_REQUIRED') {
    toast.error(
      <span>
        {message} <Link to="/dashboard/kyc" style={{ textDecoration: 'underline', fontWeight: 700 }}>Complete KYC →</Link>
      </span>
    );
    return;
  }
  toast.error(message);
}
